import { render, staticRenderFns } from "./PinList.vue?vue&type=template&id=aaf5fbbc&scoped=true&"
import script from "./PinList.vue?vue&type=script&lang=js&"
export * from "./PinList.vue?vue&type=script&lang=js&"
import style0 from "./PinList.vue?vue&type=style&index=0&id=aaf5fbbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf5fbbc",
  null
  
)

export default component.exports